import { Component, Inject, signal, isDevMode } from '@angular/core';

import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '../../core/auth.service';
import { AuthFlowService } from './auth-flow.service';

@Component({
  selector: 'app-login-modal',
  standalone: true,
  imports: [
    RouterLink,
    FormsModule,
    HttpClientModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
],
  template: `
    <h2 mat-dialog-title>Вход</h2>
    <div mat-dialog-content class="login-content">
      <mat-form-field appearance="fill">
        <mat-label>Email</mat-label>
        <input matInput type="email" [(ngModel)]="email" />
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Пароль</mat-label>
        <input matInput type="password" [(ngModel)]="password" />
      </mat-form-field>

      @if (error()) {
        <div class="error">{{ error() }}</div>
      }

      <p class="auth-links">
        Нет аккаунта? <a routerLink="/register" (click)="goTo('/register')">Зарегистрироваться</a> •
        <a routerLink="/forgot-password" class="forgot-link" (click)="goTo('/forgot-password')">Забыли пароль?</a>
      </p>

      @if (authFlow.oauthLoaded()) {
        <div class="oauth-divider"><span>или</span></div>
        <div class="oauth-buttons">
          <button mat-stroked-button color="primary" (click)="authFlow.oauthLogin('yandex')" class="oauth-yandex" [disabled]="!authFlow.oauthEnabled().yandex">Войти через Яндекс</button>
          <button mat-stroked-button (click)="authFlow.oauthLogin('google')" class="oauth-google" [disabled]="!authFlow.oauthEnabled().google">Войти через Google</button>
        </div>
      }

      @if (isDev) {
        <div class="oauth-buttons">
          <button mat-stroked-button color="warn" (click)="quickLogin()" class="quick-login">Тестовый аккаунт (2&#64;mkvm.com)</button>
        </div>
      }
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button (click)="close()">Отмена</button>
      <button mat-raised-button color="primary" (click)="submit()" [disabled]="loading() || !email || !password">Войти</button>
    </div>
  `,
  styles: [
    `.login-content{display:flex;flex-direction:column;gap:10px;min-width:360px}.error{color:#b00020;font-size:12px}.auth-links{margin:4px 0 0;font-size:13px}.forgot-link{margin-left:4px}.oauth-divider{display:flex;align-items:center;text-align:center;margin:10px 0;color:#666}.oauth-divider::before,.oauth-divider::after{content:'';flex:1;border-bottom:1px solid #ddd}.oauth-divider span{padding:0 8px;font-size:12px}.oauth-buttons{display:flex;flex-direction:column;gap:8px}.oauth-buttons button{width:100%}.oauth-yandex{background-color:#fc3f1d!important;color:#fff!important}.oauth-google{background-color:#fff!important;color:#757575!important;border-color:#ddd!important}.quick-login{background-color:#ff9800!important;color:#fff!important}`,
  ],
})
export class LoginModalComponent {
  readonly isDev = isDevMode();
  email = '';
  password = '';
  loading = signal<boolean>(false);
  error = signal<string>('');

  constructor(
    private dialogRef: MatDialogRef<LoginModalComponent>,
    public authService: AuthService,
    public authFlow: AuthFlowService,
    @Inject(MAT_DIALOG_DATA) data: { email?: string }
  ) {
    this.email = data?.email || '';
  }

  close() {
    this.dialogRef.close(false);
  }

  async submit() {
    if (!this.email || !this.password) return;
    this.loading.set(true);
    this.error.set('');

    const result = await this.authFlow.login(
      { email: this.email, password: this.password },
      () => this.dialogRef.close(true)
    );

    if (!result.success) {
      this.error.set(result.error || 'Ошибка входа');
      this.loading.set(false);
    }
  }

  async quickLogin() {
    this.loading.set(true);
    this.error.set('');

    const result = await this.authFlow.quickLogin(() => this.dialogRef.close(true));

    if (!result.success) {
      this.error.set(result.error || 'Ошибка входа');
      this.loading.set(false);
    }
  }

  goTo(path: '/register' | '/forgot-password') {
    this.dialogRef.close({ navigateTo: path });
  }
}
